"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const react_fontawesome_1 = require("@fortawesome/react-fontawesome");
const classnames_1 = __importDefault(require("classnames"));
const loading_1 = __importDefault(require("components/cosmos/loading"));
const dropdown_1 = require("components/cosmos/v2/dropdown");
const translate_1 = require("components/translate");
const UploadImageInput_module_scss_1 = __importDefault(require("./UploadImageInput.module.scss"));
const UploadImageInput = ({ width, height, label, image, onUpload, t }) => {
    const inputRef = (0, react_1.useRef)(null);
    const [isUploading, setIsUploading] = (0, react_1.useState)(false);
    const handleInputChange = async (event) => {
        const { files } = event.target;
        if (files && files.length > 0) {
            setIsUploading(true);
            const file = files[0];
            try {
                await onUpload(file);
            }
            finally {
                setIsUploading(false);
            }
        }
    };
    const renderByStatus = () => {
        if (isUploading) {
            return (0, jsx_runtime_1.jsx)(loading_1.default, { center: true, className: "_position-absolute" });
        }
        if (image) {
            return (0, jsx_runtime_1.jsx)("img", { src: image, alt: "", className: UploadImageInput_module_scss_1.default.image });
        }
        return (0, jsx_runtime_1.jsx)(react_fontawesome_1.FontAwesomeIcon, { icon: ['fal', 'camera'], className: UploadImageInput_module_scss_1.default.icon });
    };
    const renderAddButton = () => {
        return ((0, jsx_runtime_1.jsx)("button", { type: "button", className: UploadImageInput_module_scss_1.default.button, onClick: () => { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, children: label }));
    };
    const renderEditButton = () => {
        return ((0, jsx_runtime_1.jsxs)(dropdown_1.Dropdown, { children: [(0, jsx_runtime_1.jsx)(dropdown_1.Dropdown.Slot, { hasToggle: true, children: ({ slot, className }) => ((0, jsx_runtime_1.jsx)("button", { slot: slot, type: "button", className: (0, classnames_1.default)(UploadImageInput_module_scss_1.default.button, className), children: label })) }), (0, jsx_runtime_1.jsxs)(dropdown_1.Dropdown.Menu, { children: [(0, jsx_runtime_1.jsx)(dropdown_1.Dropdown.MenuItem, { onClick: () => { var _a; return (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click(); }, icon: ['fal', 'pencil'], children: t('general.edit') }), (0, jsx_runtime_1.jsx)(dropdown_1.Dropdown.MenuItem, { onClick: () => onUpload(null), icon: ['fal', 'trash'], children: t('general.remove') })] })] }));
    };
    return ((0, jsx_runtime_1.jsxs)("div", { children: [(0, jsx_runtime_1.jsx)("div", { className: UploadImageInput_module_scss_1.default.background, style: { width, height }, children: renderByStatus() }), image ? renderEditButton() : renderAddButton(), (0, jsx_runtime_1.jsx)("input", { hidden: true, ref: inputRef, type: "file", onChange: handleInputChange })] }));
};
exports.default = (0, translate_1.translate)()(UploadImageInput);
